import {store} from '../store'
import {sendFingerprint as send} from "../spirsApi/api-client";

export const sendFingerprint = () => {
    const {spirs: {fingerprint}} = store.getState();
    send({value: fingerprint}).then(() => {}, err => console.log(err));
};